
import { parse } from 'query-string'

import MyFavoritesToggle from '@dashboard/my-favorites/components/toggle'
import RatingInfo from '@internal-reviews/components/RatingInfo'

import EcoBlockAnchor from '../EcoBlockAnchor'
import Gallery from '../Gallery'

export default {
  components: {
    EcoBlockAnchor,
    Gallery,
    MyFavoritesToggle,
    RatingInfo,
  },

  props: {
    ratings: {
      type: Object,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    shouldDisplayEcoBlock: {
      type: Boolean,
      required: true,
    },

    trackingInfo: {
      type: Object,
      default: () => ({}),
    },

    activeGrade: {
      type: Object,
      required: true,
    },
  },

  computed: {
    getOfferType() {
      const hash = parse(this.$route.hash)
      const stringOfferType = hash?.offerType || '0'

      return parseInt(stringOfferType, 10)
    },
  },
}
